export default {
  ja:[
    "配送感謝します！相手の受取通知を待ってね",
    "宛先確認",
    "名前",
    "郵便番号",
    "ストリート",
    "住所",
    "都道府県",
    "国",
  ],
  en: [
    'Thanks for shipping! Please wait for the "Receive" notification!',
    "please check buyer address!",
    "name",
    "postcode",
    "street",
    "address",
    "prefecture",
    "country",
  ]
}
